import React from "react";
import { Box, IconButton, Typography } from "@mui/material";

import {
  getViewerPanelPaddingSx,
  viewerPanelBodySx,
  viewerPanelEyebrowSx,
  viewerPanelHeaderSx,
  viewerPanelHeadingGroupSx,
  viewerPanelSurfaceSx,
  viewerPanelTitleSx,
  viewerSubtleIconButtonSx,
} from "../unityWebViewer/panelStyles";
import CreditsContent from "./CreditsContent";

const CloseIcon = () => (
  <Box component="span" aria-hidden="true" sx={{ fontSize: 22, lineHeight: 1 }}>
    ×
  </Box>
);

const CreditsPanel = ({ id, onClose, open, system }) => {
  if (!open) {
    return null;
  }

  const titleId = `${id}-title`;

  return (
    <Box
      id={id}
      role="dialog"
      aria-labelledby={titleId}
      sx={{
        ...viewerPanelSurfaceSx,
        ...getViewerPanelPaddingSx(false),
        width: "100%",
        minWidth: 0,
        maxHeight: "min(62vh, 520px)",
        boxSizing: "border-box",
        color: "#f2fffc",
        overflow: "hidden",
        pointerEvents: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        component="header"
        sx={viewerPanelHeaderSx}
      >
        <Box sx={viewerPanelHeadingGroupSx}>
          <Typography
            id={titleId}
            component="h2"
            variant="overline"
            sx={{ ...viewerPanelEyebrowSx, m: 0 }}
          >
            Credits &amp; Licensing
          </Typography>
          <Typography sx={viewerPanelTitleSx}>
            {system?.name || "System credits"}
          </Typography>
        </Box>
        <IconButton
          aria-label="Close Credits & Licensing"
          onClick={onClose}
          size="small"
          sx={{ ...viewerSubtleIconButtonSx, flexShrink: 0 }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <Box
        data-testid="credits-panel-content"
        sx={{
          mt: 1.2,
          minHeight: 0,
          overflowY: "auto",
          px: 0,
          scrollbarColor: "rgba(210, 255, 249, 0.34) transparent",
          scrollbarWidth: "thin",
          textAlign: "left",
          "&::-webkit-scrollbar": {
            width: 6,
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(210, 255, 249, 0.34)",
            borderRadius: 999,
          },
        }}
      >
        {system?.description && (
          <Typography
            sx={{
              ...viewerPanelBodySx,
              mb: 1.5,
            }}
          >
            {system.description}
          </Typography>
        )}
        <CreditsContent compact credits={system?.credits} />
      </Box>
    </Box>
  );
};

export default CreditsPanel;
